import { render, staticRenderFns } from "./ExamIndividualLearner.vue?vue&type=template&id=ccf977d4&scoped=true"
import script from "./ExamIndividualLearner.vue?vue&type=script&lang=js"
export * from "./ExamIndividualLearner.vue?vue&type=script&lang=js"
import style0 from "./ExamIndividualLearner.vue?vue&type=style&index=0&id=ccf977d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf977d4",
  null
  
)

export default component.exports